import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "DeductItem" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { modalConfig } from './config/modal.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { usePageModal } from '@/hooks/usePageModal'
import { ref } from 'vue'
import PageSearch from '@/components/PageSearch.vue'
import PageContent from '@/components/PageContent.vue'
import PageModal from '@/components/PageModal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeductItem',
  setup(__props) {

const modalTitle = ref('新增')
const newCb = () => {
  modalTitle.value = '新增积分扣除项'
}

const editCb = () => {
  modalTitle.value = '编辑积分扣除项'
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)

const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "deductItem",
      deleteTip: "确认删除此扣除项吗？",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData)
    }, {
      flow: _withCtx((scope) => [
        (scope.row.flow === '0')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "减积分"))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, "加积分"))
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "deductItem",
      validOtherInfo: () => true
    }, null, 8, ["defaultInfo", "modalConfig", "title"])
  ]))
}
}

})